import Vue from 'vue';
import Component from 'vue-class-component';
import dayjs from 'dayjs';

import { DATE_TIME_LONG_FORMAT } from '@/shared/date/filters';
import { Prop, PropSync, Watch } from 'vue-property-decorator';

@Component
export default class AutoValidateDateField extends Vue {
  @PropSync('referenceProp') reference: any;
  @PropSync('loadingProp') loading: boolean;
  @Prop() label: string;
  @Prop() disable: boolean;

  private showMenu = false;
  private inputValue = '';
  private hasError = false;
  private maxDate = dayjs().year(2050).format(DATE_TIME_LONG_FORMAT);
  private minDate = dayjs().year(1950).format(DATE_TIME_LONG_FORMAT);

  @Watch('loading')
  handelInitValues() {
    if (!this.loading) {
      this.inputValue = this.formatted;
    }
  }

  private onInput() {
    const raw = this.inputValue;
    if (!raw) {
      this.hasError = false;
      this.inputValue = null;
      this.reference = null;
      return;
    }
    const parts = raw.split('.').map(part => part.replace(/\D/g, ''));

    let day = parts[0] || '';
    let month = parts[1] || '';
    const year = parts[2] || '';
    const lastChar = this.inputValue.charAt(this.inputValue.length - 1);

    if (day.length === 1 && Number(day) > 3) {
      day = '0' + day;
    } else if (day.length === 1 && lastChar === '.') {
      day = '0' + day;
    } else if (day.length > 2) {
      day = day.slice(0, 2);
    }
    if (Number(day) > 31) {
      day = '31';
    }

    if (month.length === 1 && Number(month) > 1) {
      month = '0' + month;
    } else if (month.length === 1 && lastChar === '.') {
      month = '0' + month;
    } else if (month.length > 2) {
      month = month.slice(0, 2);
    }
    if (Number(month) > 12) {
      month = '12';
    }

    let formatted = day;
    if (raw.includes('.') || month) formatted += '.' + month;
    if (raw.split('.').length >= 3 || year) formatted += '.' + year;
    if (formatted.length < 10) {
      if (formatted.length === 2) {
        formatted += '.';
      } else if (formatted.length === 5) {
        formatted += '.';
      }
    }

    this.inputValue = formatted;

    if (this.isValidDateFormat(formatted)) {
      const [d, m, y] = formatted.split('.');
      const date = dayjs()
        .year(Number(y))
        .month(Number(m) - 1)
        .date(Number(d))
        .toDate();

      if (
        !isNaN(date.getTime()) &&
        Number(y) >= 1950 &&
        Number(y) <= 2050 &&
        date.getDate() === Number(d) &&
        date.getMonth() === Number(m) - 1 &&
        date.getFullYear() === Number(y)
      ) {
        this.reference = date;
        this.hasError = false;
      } else {
        this.hasError = true;
      }
    } else {
      this.hasError = false;
    }
  }

  private onBlur() {
    if (!this.inputValue) {
      this.hasError = false;
      this.reference = null;
      this.inputValue = null;
      return;
    }
    if (!this.isValidDateFormat(this.inputValue)) {
      this.hasError = true;
      return;
    }

    const [d, m, y] = this.inputValue.split('.');
    const date = dayjs()
      .year(Number(y))
      .month(Number(m) - 1)
      .date(Number(d))
      .toDate();

    if (
      !isNaN(date.getTime()) &&
      Number(y) >= 1950 &&
      Number(y) <= 2050 &&
      date.getDate() === Number(d) &&
      date.getMonth() === Number(m) - 1 &&
      date.getFullYear() === Number(y)
    ) {
      this.reference = date;
      this.hasError = false;
    } else {
      this.hasError = true;
    }
  }

  private isValidDateFormat(value: string): boolean {
    const regex = /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.(\d{4})$/;
    return regex.test(value);
  }

  private get formatted(): string {
    return this.reference ? dayjs(this.reference).format('DD.MM.YYYY') : '';
  }

  private set formatted(newValue: string) {
    this.inputValue = newValue;
  }

  private get datePickerModel() {
    return this.reference ? dayjs(this.reference).format('YYYY-MM-DD') : null;
  }

  private set datePickerModel(newValue: string) {
    const currentDate = new Date();
    const dateTime =
      newValue + 'T' + currentDate.getHours().toString().padStart(2, '0') + ':' + currentDate.getMinutes().toString().padStart(2, '0');
    this.reference = dayjs(dateTime, DATE_TIME_LONG_FORMAT).toDate();
    setTimeout(() => {
      this.inputValue = this.formatted;
    }, 250);
    this.hasError = false;
  }
}
